import config from "../../../config";

export const connectWebSocket = (itemId, token) => {
  return new WebSocket(`${config.wsUrl}${itemId}/ws?token=${token}`);
};
